import { render, staticRenderFns } from "./validation-status-label.vue?vue&type=template&id=6c031aa2&scoped=true"
import script from "./validation-status-label.vue?vue&type=script&lang=js"
export * from "./validation-status-label.vue?vue&type=script&lang=js"
import style0 from "./validation-status-label.vue?vue&type=style&index=0&id=6c031aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c031aa2",
  null
  
)

export default component.exports